module.exports = __webpack_public_path__ + "static/background-1-fa230938007ac936f09cdfc13f0a5615.png";